module.exports = __webpack_public_path__ + "img/industries.0cf8e880.svg";